import { useState } from "react"

import { ContentObjectItem } from "@vertesia/common"
import { toast } from "sonner"

import { Button } from "@ui/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@ui/dialog"
import { useUserSession } from "@session/UserSession"

interface DeleteDocumentModalProps {
    document: ContentObjectItem
    open: boolean
    setOpen: (open: boolean) => void
    onDelete: () => void
}
export function DeleteDocumentModal({ document, open, setOpen, onDelete }: Readonly<DeleteDocumentModalProps>) {
    const { client } = useUserSession()

    const [isDeleting, setIsDeleting] = useState(false)

    const deleteDocument = () => {
        setIsDeleting(true)
        client.objects.delete(document.id).then(() => {
            toast.success("Document Deleted", {
                description: `Document ${document.id} has been deleted successfully`,
                duration: 4000
            })
            onDelete()
            setOpen(false)
        }).catch((error) => {
            toast.error("Error Deleting Document", {
                description: "error.message",
                duration: 4000
            })
            setIsDeleting(false)
        })
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Document</DialogTitle>
                </DialogHeader>
                <p>Are you sure you want to delete this document?</p>
                <DialogFooter>
                    <Button variant="destructive" onClick={() => setOpen(false)} disabled={isDeleting}>Cancel</Button>
                    <Button variant="outline" onClick={deleteDocument} disabled={isDeleting}>
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}